/**
 * UI range DatePicker ↔ listQuery.filters（API：`repair_request_date_from`／`to`）。
 */
import { formatApiDateRangeDisplay } from '#/utils/date';

export function readRepairRequestDateRangeFilter(filters = {}) {
  const from = filters.repairRequestDateFrom;
  const to = filters.repairRequestDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyRepairRequestDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.repairRequestDateFrom;
    delete next.repairRequestDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.repairRequestDateFrom = from || undefined;
  next.repairRequestDateTo = to || undefined;

  return next;
}

export function resolveRepairRequestDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.repairRequestDateFrom,
    to: ctx.filters?.repairRequestDateTo,
  });

  return display ? [display] : [];
}
